<template>
  <ul class="nav sub-nav justify-content-center">
    <li class="nav-item" :key="item" v-for="item in nav">
      <router-link
        class="nav-link"
        :class="{
          'active': isIncludedInRoute(item)
        }"
        :to="item.to"
      >
        {{ item.label }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "HeaderSetting",
  data() {
    return {
      nav: [
        {
          label: "基本情報",
          to: "/service-account",
        },
        {
          label: "通知アドレス",
          to: "/notification-recipients",
        },
        {
          label: "監視デバイス",
          to: "/monitoring-devices",
        },
        {
          label: "請求書・領収書",
          to: "/billings",
        },
      ],
    };
  },
  methods: {
    isIncludedInRoute(navItem) {
      if (!navItem.to || navItem.to === "#") {
        return false;
      }

      return this.$route.path.includes(navItem.to);
    },
  },
};
</script>
